import { useSelectedLocation } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { getChecklistById } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

import type { ChecklistID, DealerID } from "models";

type AttachChecklistToDealerPayload = {
  checklist_id: ChecklistID;
  dealer_id: DealerID;
};

export const useAttachChecklistToDealerMutation = () => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedMutation<AttachChecklistToDealerPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/checklists/dealer/attach", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ checklist_id, dealer_id }) => {
      const dealerChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(dealer_id)) ?? [];
      if (dealerChecklists.some(dc => dc.id === checklist_id)) return;

      const checklist = getChecklistById(checklist_id, dealer_id, selectedLocation?.id);
      if (!checklist) return;

      typedQueryClient.setQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(dealer_id), [checklist, ...dealerChecklists]);
    }
  });
};
